<template>
  <CircleChart :isPercentage="isPercentage" :score="score" :name="name">
    <template v-slot:default="slotProps">
      <text
        x="100"
        y="140"
        v-if="score !== null"
        text-anchor="middle"
        transform="matrix(1 0 0 1 0 0)"
        >{{ slotProps.label }}
      </text>
    </template>
  </CircleChart>
</template>

<script>
import CircleChart from '@/components/CustomSurveys/Reports/CircleChart.vue'

export default {
  components: { CircleChart },

  props: {
    score: { type: Number, default: null },
    name: { type: String, default: '' },
    isPercentage: { type: Boolean, default: false },
  },
}
</script>
